/** @format */

import React, {
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
  MouseEvent,
} from 'react';
import Translate from '@components/translation/translate-text-wrapper';

interface ModalWrapperProps {
  children: JSX.Element | JSX.Element[];
  showModal?: boolean;
  id?: string;
  className?: string;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

/**
 * Modal Wrapper.
 */
const ModalWrapper = ({
  children,
  showModal,
  className,
  setShowModal,
}: ModalWrapperProps) => {
  const modal = useRef<HTMLDialogElement>(null);

  /**
   * Click backdrop to close Modal.
   */
  const backdropCloseModal = (event: React.MouseEventHandler<HTMLElement>) => {
    if (event.target.tagName === 'DIALOG') {
      setShowModal(false);
    }
  };

  /**
   * Listen for Modal "close" - needed for "Esc" key press.
   */
  useEffect(() => {
    modal.current?.addEventListener('close', () => {
      if (setShowModal) {
        setShowModal(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Shows/Closes Modal.
   */
  useEffect(() => {
    if (showModal) {
      modal.current?.showModal();
    } else {
      modal.current?.close();
    }
  }, [showModal]);

  /**
   * Render.
   */
  return (
    <dialog
      ref={modal}
      onClick={(e: MouseEvent) => backdropCloseModal(e)}
      id="modal-wrapper"
      className={className}>
      <div className="dialog-inner-container">
        <button
          type="button"
          className="close-modal"
          onClick={() => setShowModal(false)}>
          <Translate>Close</Translate>
        </button>
        {children}
      </div>
    </dialog>
  );
};

export default ModalWrapper;
